<div class="mat-typography">
    @if (data.entity.is_owned_by_current_user) {
        <div class="dialog-header">
            Share {{ entityName }}
        </div>

        <div class="horizontal-separator"></div>
    }
    <div class="dialog-container">
        @if (data.entity.is_owned_by_current_user && this.data.canShare) {
            <div class="search_bar">
                <div class="search-field"
                     [ngClass]="{ selected: this.userSearchCtrl.value?.length }">
                    <mat-form-field appearance="outline">
                        <input
                                type="text"
                                class="wider-options"
                                placeholder="Search by email"
                                matInput
                                [formControl]="userSearchCtrl"
                                [matAutocomplete]="auto"
                        >
                        <mat-autocomplete
                                [displayWith]="displayName"
                                #auto="matAutocomplete">
                            @for (user of users$ | async; track user) {
                                <mat-option [value]="user">
                                    {{ user.email }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                    <div class="separator"></div>
                    <mat-form-field appearance="outline" class="search-select">
                        <mat-select
                                [formControl]="roleType"
                                panelClass="search-panel"
                        >
                            <mat-option value="read">Can Read</mat-option>
                            <mat-option value="all">Can Edit</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <button mat-button class="frmg-primary-button" [disabled]="userSearchCtrl.invalid"
                        (click)="share()">Share
                </button>
            </div>
            <p class="input-label">People with access</p>
        }
        <div class="shared_users">
            @for (user of sharedUsers; track user) {
                <div class="user_container">
                    <frmg-user-logo [user]="user"></frmg-user-logo>
                    <div class="info">
                        <div class="email">{{ user.email || user['X-Pomerium-Claim-Email'] }}</div>
                        <div class="name">{{ user.first_name }}  {{ user.last_name }}</div>
                    </div>
                    @if ($index !== 0) {
                        @if (user.email === currentUser['X-Pomerium-Claim-Email'] || (this.data.entity.is_owned_by_current_user && this.data.canShare)) {
                            <mat-form-field appearance="outline" class="search-select">
                                <mat-select [formControl]="getUserRoleCtrl(user.email)"
                                            panelClass="search-panel">
                                    @if (this.data.entity.is_owned_by_current_user ||
                                    (user.email === currentUser['X-Pomerium-Claim-Email']) && getUserRoleCtrl(user.email).value === 'read') {
                                        <mat-option value="read">Can Read</mat-option>
                                    }
                                    @if (this.data.entity.is_owned_by_current_user ||
                                    (user.email === currentUser['X-Pomerium-Claim-Email']) && getUserRoleCtrl(user.email).value === 'all') {
                                        <mat-option value="all">Can Edit</mat-option>
                                    }
                                    <mat-option value="revoke">Revoke</mat-option>
                                </mat-select>
                            </mat-form-field>
                        } @else {
                            {{ getUserRoleCtrl(user.email).value === 'read' ? 'Can Read' : 'Can Edit' }}
                        }
                    }
                    @if ($index == 0) {
                        <div class="owner">
                            <inline-svg src="Key.svg" color="#A5B5BD"></inline-svg>
                            <span>Owner</span>
                        </div>
                    }
                </div>
            }
        </div>
    </div>

</div>
<div class="button-row ">
    <button mat-button (click)="closeDialog()" class="cancel-button">Close
    </button>
</div>
